<template>
  <div class="dialog_container">
    <el-dialog
      title="新增车辆检测记录"
      :visible="dialogShow"
      width="837px"
      @close="dialogClose"
      top="4vh"
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <div class="form_title">基本信息</div>
        <el-form
          ref="addForm"
          class="add_staff_form"
          :model="addForm"
          label-width="130px"
          :rules="addRules"
        >
          <el-form-item label="车牌号码：" prop="carId">
            <el-select
              v-model="addForm.carId"
              placeholder="请选择车辆"
              @change="carChange"
            >
              <el-option
                v-for="item in carList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车牌颜色：">
            <el-input
              placeholder="选择车辆后自动填充"
              v-model="carColor"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="车辆类型：">
            <el-input
              placeholder="选择车辆后自动填充"
              v-model="carType"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="厂牌型号：">
            <el-input
              placeholder="选择车辆后自动填充"
              v-model="carModel"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="车辆营运性质：">
            <el-input
              placeholder="选择车辆后自动填充"
              v-model="carNature"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="车主单位：">
            <el-input
              placeholder="选择车辆后自动填充"
              v-model="carUnit"
              disabled
            ></el-input>
          </el-form-item>

          <div class="form_title">检测信息</div>
          <el-form-item label="检测单位：" prop="detectCompany">
            <el-input
              v-model="addForm.detectCompany"
              placeholder="请输入检测单位"
            ></el-input>
          </el-form-item>
          <el-form-item label="检测时间：" prop="detectTimeStr">
            <el-date-picker
              type="date"
              placeholder="选择检测时间"
              v-model="addForm.detectTimeStr"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="检测类型：" prop="detectType">
            <el-select
              v-model="addForm.detectType"
              placeholder="请选择检测类型"
            >
              <el-option
                v-for="item in detectTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下次检测时间：" prop="nextDetectTimeStr">
            <el-date-picker
              type="date"
              placeholder="选择下次检测时间"
              v-model="addForm.nextDetectTimeStr"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="检测结果：" prop="detectResult">
            <el-input
              v-model="addForm.detectResult"
              placeholder="请输入检测结果"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="form_title">附件</div>
        <div class="uploading_box">
          <div class="certificate">
            <el-upload
              class="avatar-uploader"
              action="http://47.101.220.89:8687/file/uploadFile"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
              :http-request="uploadFile"
            >
              <div v-if="addForm.detectFile" class="img_box">
                <img :src="imgHttp + addForm.detectFile" class="avatar" />
              </div>
              <div v-else>
                <div class="card_title">检测报告</div>
                <img
                  class="uploading_icon"
                  src="../../../../static/images/idCard_icon.png"
                  alt=""
                />
              </div>
            </el-upload>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('addForm')"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { dateTransition } from "@/utils/util";
import config from '@/utils/config'
export default {
  name: "",
  data() {
    return {
      textarea: "",
      addForm: {},
      receiveList: [],
      carList: [],
      carColor: "",
      carType: "",
      carModel: "",
      carNature: "",
      carUnit: "",
      imgHttp:"",
      addRules: {
        carId: [{ required: true, message: "请选择车辆", trigger: "change" }],
        detectCompany: [
          { required: true, message: "请输入检测单位", trigger: "blur" },
        ],
        detectTimeStr: [
          { required: true, message: "选择检测时间", trigger: "change" },
        ],
        detectType: [
          { required: true, message: "请选择检测类型", trigger: "change" },
        ],
        nextDetectTimeStr: [
          { required: true, message: "选择下次检测时间", trigger: "change" },
        ],
        detectResult: [
          { required: true, message: "请输入检测结果", trigger: "blur" },
        ],
      },
      detectTypeList: [],
      headers:{}
    };
  },
  components: {},
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dialogShow(val) {
      if (val) {
        this.headers = {
          Authorization: sessionStorage.getItem("Token"),
          "Content-Type": "multipart/form-data",
        };
        this.imgHttp = config.baseUrl;
        this.$http.getRepairSelect(3).then((res) => {
          if (res.code === 0) {
            this.carList = res.data;
          }
        });
        this.$http.getDetectTypeSelect().then((res) => {
          if (res.code === 0) {
            this.detectTypeList = res.data;
          }
        });
      }
    },
  },
  created() {},
  methods: {
    carChange(e) {
      console.log(e);
      this.carList.forEach((i) => {
        if (i.id == e) {
          this.carColor = i.carColorStr || " ";
          this.carType = i.carTypeStr || " ";
          this.carModel = i.carFactoryModel || " ";
          this.carNature = i.carServiceStr || " ";
          this.carUnit = i.companyName || " ";
        }
      });
    },
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.addForm.nextDetectTimeStr = dateTransition(
          this.addForm.nextDetectTimeStr
        );
        this.addForm.detectTimeStr = dateTransition(
          this.addForm.detectTimeStr
        );
        this.$http.addDetectInfo(this.addForm).then((res) => {
          if (res.code === 0) {
            this.$message.success(res.msg);
            this.$parent.getList();
            this.addForm = {};
            this.$emit("update:dialogShow", false);
          } else {
            this.$message.info(res.msg);
          }
        });
      });
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
    uploadFile(file) {
      var that = this;
      console.log(file);
      const formData = new FormData();
      formData.append("file", file.file);

      console.log(formData);
      that.$http.uploadFile(formData).then((res) => {
        console.log(res);
        that.addForm.detectFile = res.msg;
        that.$forceUpdate();
      });
    },
    beforeAvatarUpload(file) {
      console.log(file.type);
      const isType =
        file.type == "image/jpg" ||
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "application/pdf" ||
        file.type == "application/msword" ||
        file.type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document";;
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (!isType || !isLt20M) {
        this.$message.error(
          "请上传格式为jpg、jpeg、png、pdf、doc、docx且大小不超过20M的图片或文件"
        );
      }
      return isType && isLt20M;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";
.uploading_box {
  display: flex;
  flex-wrap: wrap;
  .certificate {
    width: 238px;
    height: 157px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    margin-bottom: 3px;
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader {
      width: 100%;
      height: 100%;
      border-radius: 2px;
      border: 1px solid #d1d1d1;
      display: flex;
      justify-content: center;
      align-items: center;
      .card_title {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
      }
      .uploading_icon {
        width: 91px;
        height: 70px;
        margin-top: 15px;
      }

      .img_box {
        width: 238px;
        height: 157px;
        .avatar {
          width: 100%;
          height: 100%;
          margin-top: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/maintainRecord_component/addCarInspect.vue